import React from "react";
import { Helmet } from "react-helmet-async";

import { Hero } from "../components/Hero";
import { TrustBar } from "../components/TrustBar";
import { FuzzFeature } from "../components/FuzzFeature";
import { VibeFeature } from "../components/VibeFeature";
import { SOSFeature } from "../components/SOSFeature";
import { HowItWorks } from "../components/HowItWorks";
import { UseCases } from "../components/UseCases";
import { Testimonials } from "../components/Testimonials";

// import { FinalCTA } from "../components/FinalCTA";
import { Privacy } from "@/components/Privacy";
// import { About } from "@/components/About";

const Home = () => {
  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Fuzz – Stay Connected with People Nearby</title>
        <meta
          name="description"
          content="Fuzz helps you connect with people nearby, build trusted circles, and stay safe with real-time proximity and SOS alerts."
        />
        <link rel="canonical" href="https://fuzzpreview.myzow.in/" />
      </Helmet>

      <main>
          <Hero />
          <TrustBar />
          <FuzzFeature />
          <VibeFeature />
          <SOSFeature />
          <HowItWorks />
          <UseCases />
          <Testimonials />
          {/* <About/> */}
          <Privacy />
          {/* <FinalCTA /> */}
      </main>
    </>
  );
};

export default Home;